import isAuth from "@/middleware/isAuth";
import isStudent from "@/middleware/isStudent";

const gate = [isAuth, isStudent];

export default [
  {
    path: "/student",
    component: () =>
      import(/* webpackChunkName: "student-shell" */ "@/layouts/student.vue"),
    meta: {
      layout: "plain",
      portal: "student",
    },
    children: [
      {
        path: "",
        name: "StudentHome",
        component: () =>
          import(
            /* webpackChunkName: "student-home" */ "@/views/student/home.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_home",
          descriptionKey: "student_home_hint",
        },
      },
      {
        path: "subjects",
        name: "StudentSubjects",
        component: () =>
          import(
            /* webpackChunkName: "student-subjects" */ "@/views/student/subjects.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_subjects",
          descriptionKey: "student_subjects_hint",
        },
      },
      {
        path: "exams",
        name: "StudentExams",
        component: () =>
          import(
            /* webpackChunkName: "student-exams" */ "@/views/student/exams.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "exams",
          descriptionKey: "student_exams_hint",
        },
      },
      {
        path: "library",
        name: "StudentLibrary",
        component: () =>
          import(
            /* webpackChunkName: "student-library" */ "@/views/student/library.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_library",
          descriptionKey: "student_library_hint",
        },
      },
      {
        path: "religion",
        name: "StudentReligion",
        component: () =>
          import(
            /* webpackChunkName: "student-religion" */ "@/views/student/religion.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_religion",
          descriptionKey: "student_religion_hint",
        },
      },
      {
        path: "quizzes",
        name: "StudentQuizzes",
        component: () =>
          import(
            /* webpackChunkName: "student-quizzes" */ "@/views/student/quizzes.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_quizzes",
          descriptionKey: "student_quizzes_hint",
        },
      },
      {
        path: "quizzes/create",
        name: "StudentQuizCreate",
        component: () =>
          import(
            /* webpackChunkName: "student-quiz-create" */ "@/views/student/quizCreate.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_quiz_create",
          descriptionKey: "student_quiz_create_hint",
        },
      },
      {
        path: "quizzes/solutions",
        name: "StudentQuizSolutions",
        component: () =>
          import(
            /* webpackChunkName: "student-quiz-solutions" */ "@/views/student/quizSolutions.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_quiz_solutions",
          descriptionKey: "student_quiz_solutions_hint",
        },
      },
      {
        path: "quizzes/:id",
        name: "StudentQuizTake",
        component: () =>
          import(
            /* webpackChunkName: "student-quiz-take" */ "@/views/student/quizTake.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_quiz_take",
          descriptionKey: "student_quiz_take_hint",
        },
      },
      {
        path: "competitions",
        name: "StudentCompetitions",
        component: () =>
          import(
            /* webpackChunkName: "student-competitions" */ "@/views/student/competitions.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_competitions",
          descriptionKey: "student_competitions_hint",
        },
      },
      {
        path: "competitions/:id",
        name: "StudentCompetitionTake",
        component: () =>
          import(
            /* webpackChunkName: "student-competition-take" */ "@/views/student/competitionTake.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "student_competition_take",
          descriptionKey: "student_competition_take_hint",
        },
      },
    ],
  },
];
